// extracted by mini-css-extract-plugin
module.exports = {"wideCard":"FeaturedAcademy_wideCard__EnF4V"};